import IsOpen from "../../components/IsOpen"
import WaitTime from "../../components/WaitTime"
import FulfillmentMethods from "../../components/FulfillmentMethods"
import {PAYEE_CATALOG_TYPE_ORDERING} from "../../constants/payeeCatalog"

const OrderingCatalogHeader = ({catalogConfig={}}) => {
    if (typeof catalogConfig !== "object") return null
    const config = catalogConfig[PAYEE_CATALOG_TYPE_ORDERING]
    if (!config || typeof config !== "object") return null
    const {openingHours, prepTimes, fulfillment} = config 
    const {avg="", buffer=""} = prepTimes || {}
    return (
        <div className="margin-top-5px font-size-14px text-align-center  gap-2">
            {
                openingHours && typeof openingHours === "object" ?
                <IsOpen openingHours={openingHours}/> 
                :
                null
            }
            {
                prepTimes ?
                <div className="margin-top-5px"><WaitTime avg={avg} buffer={buffer}/></div>
                :
                null
            }   
            {
                fulfillment ?
                <div className="margin-top-5px"><FulfillmentMethods methods={fulfillment}/></div>
                :
                null
            }   
        </div>
    )
}

export default OrderingCatalogHeader